// extracted by mini-css-extract-plugin
module.exports = {"navbar":"SettingsNavbar_navbar__1L95V","item":"SettingsNavbar_item__2rywq","active":"SettingsNavbar_active__1_-Ao"};